<div class="container" style="padding-top: 1rem">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-lg-6 col">
        <mat-card appearance="outlined">
          <mat-card-title class="pb-3">Mailjet-Kontaktlisten-Export</mat-card-title>
          <div class="row">
            <mat-form-field>
              <mat-label>Benutzergruppe</mat-label>
              <mat-select (valueChange)="checkGroup()" ngDefaultControl formControlName="usertype">
                <mat-option [value]="UserType.HP">HP</mat-option>
                <mat-option [value]="UserType.MA">MA</mat-option>
                <mat-option [value]="UserType.IP">IP</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="row">
            @if (form.controls.usertype.value === UserType.IP) {
              <mat-form-field>
                <mat-label>Pitch</mat-label>
                <mat-select formControlName="cycleFilter">
                  <mat-option [value]="'all'">Alle</mat-option>
                  <mat-option [value]="'none'">(ohne Zuordnung)</mat-option>
                  @for (c of cycles$ | async; track c.uuid) {
                    <mat-option [value]="c.uuid">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Status</mat-label>
                <mat-select formControlName="statusIn" multiple>
                  <mat-option [value]="'created'">angelegt</mat-option>
                  <mat-option [value]="'requested'">angefordert</mat-option>
                  <mat-option [value]="'denied'">abgelehnt</mat-option>
                  <mat-option [value]="'approved'">bestätigt</mat-option>
                  <mat-option [value]="'invited'">eingeladen</mat-option>
                  <mat-option [value]="'notinvited'">nicht eingeladen</mat-option>
                </mat-select>
              </mat-form-field>
            }
            @if (form.controls.usertype.value === UserType.HP) {
              <mat-checkbox formControlName="voting">Nur Voting berechtigte</mat-checkbox>
            }
          </div>
        </mat-card>

        <mat-card appearance="outlined">
          <div class="export">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Name der Liste</mat-label>
                  <input matInput formControlName="name" required />
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <markant-button [disabled]="!form.valid" (click)="export()">Übertragen nach Mailjet</markant-button>
              </div>
              @if (jobStatus$ | async; as info) {
                @if (info.status === JobStatus.COMPLETED) {
                  <div class="col-md-8 job-status">Erfolgreich exportiert: <a href="https://app.mailjet.com/contacts" target="_blank">Zur Kontaktliste</a></div>
                } @else if (info.status === JobStatus.UPLOAD) {
                  <div class="col-md-8 job-status">Upload zur Mailjet Kontaktliste läuft.</div>
                } @else if (info.status === JobStatus.ERROR) {
                  <div class="col-md-8 job-status">Fehler: {{ info.error }}</div>
                } @else {
                  <div class="col-md-8 job-status">Status lädt...</div>
                }
              }
            </div>
          </div>
        </mat-card>
      </div>

      <div class="col-lg-6 col">
        <ng-container *ngTemplateOutlet="preview"></ng-container>
      </div>
    </div>
  </form>
</div>

<ng-template #preview>
  <mat-card appearance="outlined">
    <mat-card-title>Vorschau</mat-card-title>
    <p>Hier werden die ersten 10 Einträge der zu erstellenden Kontaktliste angezeigt.</p>

    <table mat-table #table [dataSource]="previewContacts$">
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let contact">{{ contact.firstName }} {{ contact.lastName }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>E-Mail</th>
        <td mat-cell *matCellDef="let contact">
          {{ contact.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef>Produkt</th>
        <td mat-cell *matCellDef="let contact">
          {{ contact.productName }}
        </td>
      </ng-container>
    </table>
  </mat-card>
</ng-template>
